import { memo } from 'react'

import ArcNavBar, { TEST_ID } from './ArcNavBar'

const ArcNavBarComponent = memo(ArcNavBar)

export { TEST_ID }

export default ArcNavBarComponent
